import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/")({
  // Component moved to $orgSlug.admin.index.lazy.tsx for code splitting
});
